export default __webpack_public_path__ + "static/media/008-lunar roving vehicle.1dbc6aee.svg";